<template>
  <div class="">
    <div class="content">
        <div v-if="order" class="single">
          <Order :order="order"></Order>
        </div>
        <div v-else>
          <v-card-title>
              
              <v-spacer></v-spacer>
              <v-text-field  v-model="search" append-icon="search" :label="$t('admin.views.orders.filter')" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :custom-filter="filter" :headers="headers" :items="orders" class="elevation-1" :no-results-text="message_not_found" :rows-per-page-items="rows_per_page" :pagination.sync="pagination" :search="search"
          :rows-per-page-text="message_rows_per_page">
              <template v-slot:items="props">
                  <td>
                    {{ market === 'PT' ? '#O-' : (market === 'ES' ? '#P-' : '#') }}{{ props.item.number }}
                  </td>
                  <td>{{ props.item.contact_name }}</td>
                  <td>{{ props.item.restaurant_site }} - {{ props.item.restaurant_name }}</td>
                  <td>{{ formatDate( props.item.date ) }}</td>
                  <td>
                    <div :class="'status s' + props.item.status">
                      <img :src="'/img/icons/status-' + props.item.status + '.png'" />
                      <span>{{ $t('views.orders.status.' + props.item.status) }}</span>
                    </div>
                  </td>
                  <td>{{ num( props.item.items ) }}</td>
                  <td><v-icon @click="edit(props.item)">edit</v-icon><v-icon @click="remove(props.item)">delete</v-icon></td>
              </template>
          </v-data-table>
        </div>
    </div>

  </div>
</template>

<script>
import i18n from "@/i18n";
import Order from '@/components/domain/admin/Order'

export default {
  name: 'Orders',
  props: { page: String },
  components: { Order },
  data () {
    return {
      headers: [
          { text: i18n.t('general.name'), value: 'name' },
          { text: i18n.t('general.headers.user'), value: "user" },
          { text: i18n.t('general.headers.restaurant'), value: "restaurant" },
          { text: i18n.t('general.headers.date'), value: "date" },
          { text: i18n.t('general.headers.status'), value: "status" },
          { text: i18n.t('general.headers.items'), value: "items" },
          { text: '', value: "actions" }
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rows_per_page: [
                        10,
                        50,
                        100,
                        {"text":"Todos", "value": -1}
                    ],
      pagination: {
          rowsPerPage: -1,
          sortBy: 'date',
          descending: true
      },
      status: this.$store.getters['orders/getOrderStatus']
    }
  },
  computed: {
    orders() {
      console.log( this.$store.getters['orders/getOrders'] );
        var orders = ObjectToArray( this.$store.getters['orders/getOrders'] );
        console.log( orders );
        return orders;
    },
    order(){
        return this.$store.getters['orders/getCurrentOrder'];
    },
    market(){
      return this.$store.getters['getMarket'];
    }
  },
  methods: {
        edit( order ){
            console.log( order );
            this.$store.commit( 'orders/setCurrentOrder', order );
        },
        remove( order ){
            var self = this;
            this.$popup.confirm( 
              i18n.t('admin.views.orders.popup.delete'), 
              i18n.t('admin.views.orders.popup.delete_message', { name: order.name }), 
              i18n.t('general.accept'), 
              i18n.t('general.cancel'),
              function(){
                self.$store.dispatch( 'orders/removeOrder', order.id );
              }
            );
        },
        num( param ){
            if( typeof param === 'object' ){
                return ObjectToArray( param ).length;
            }
            return param.length;
        },
        formatDate( date ) {
          return moment( date ).format( "HH:mm DD/MM/YYYY" );
        },
        filter( items, search, filter ){          
          var aItems = [];
          search = search.toLowerCase();
          
          items.forEach( item => {
            const nameMatch = (item.name || '').toLowerCase().includes(search);
            const statusMatch = (this.status[item.status].name || '').toLowerCase().includes(search);
            const restaurantMatch = (item.restaurant_name || '').toLowerCase().includes(search);
            const contactMatch = (item.contact_name || '').toLowerCase().includes(search);
            const dateMatch = (this.formatDate(item.date) || '').toLowerCase().includes(search);
            
            if( nameMatch || statusMatch || restaurantMatch || contactMatch || dateMatch ){
              aItems.push( item );
            }
          });
          return aItems;
        }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit('setTitle', this.$t('general.headers.orders'));
    this.$store.commit('setMenuVisible', false);

    var self = this;
    this.$store.dispatch('orders/loadOrders', {}).then(function(){
      switch( self.page ){
          case 'edit':self.$store.commit( 'orders/setCurrentOrderByID', self.$route.params.id ); 
                      break;
          default: break;
      }
    });
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


  .sidebar-cnt {
    width: 300px;
    display: inline-block;
    float: left;
  }
  .content {
    width: 100%;
    display: inline-block;
    float: left;
    padding: 20px 40px;

    .status {
      width: fit-content;
      height: 24px;
      border-radius: 4px;
      padding: 4px 8px;
      display: flex;
      align-items: center;

      img {
        height: 16px;
        width: 16px;
        margin-right: 4px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        padding: 0px;
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
      }

      &.s1 {
        background-color: black;
        span {
          color: white;
        }
        > img {
          filter: invert(1);
        }
      }

      &.s2 {
        background-color: #DDDDDD;
        span {
          color: #111111;
        }
      }

      &.s3 {
        background-color: #ffeb3b;
        span {
          color: #111111;
        }
      }
      
      &.s4 {
        background-color: #96d6be;
        span {
          color: #111111;
        }
      }

      &.s5 {
        background-color: #ff9e80;
        span {
          color: #111111;
        }
      }
    }

    .header {
      width: 100%;
      text-align: left;
      margin-bottom: 15px;
      overflow: hidden;

      .meta {
        float: left;
        width: 70%;

        .breadcrumbs {
          color: #aaa;
          display: block;
          width: 100%;

          .cat1 {
            display: inline-block;
            font-weight: bold;
            font-family: Speedee-Bold;
          }
          .cat2 {
            display: inline-block;
            
            &:before {
              content: "|";
              margin: 0 5px;

            }
          }
        }
        .title {
          background: var(--main_color);
          color: var(--dark_color);
          width: auto;
          display: inline-block;
          text-align: left;
          float: left;
          font-size: 25pt;
          font-family: Speedee-Bold;
          padding: 0 5px;
          margin: 0;
          margin-top: 5px;
          line-height: 25pt;
          padding-bottom: 5px;
        }
      }

      .filter {
        float: left;
        width: 30%;
        text-align: right;
        padding: 0 10px;

        .search {
          display: block;
          overflow: hidden;
          margin-top: 5px;
          -webkit-transition: all 1s;
          transition: all 1s;


          .input {
            border: none;
            border-bottom: 2px solid #ccc;
            padding: 5px;
            outline: none;
            background: url('/img/magnify.svg') no-repeat right 5px center;
            background-size: 20px;
            width: 100%;
            float: left;
          }
          .icon {
            display: none;
            cursor: pointer;
            width: 30px;
            height: 30px;
            background: url('/img/go.svg') no-repeat center var(--main_color);
            background-size: 20px;
            border-radius: 3px;
          }
          &.active {
            

            .input {
              width: calc( 100% - 40px );
              background: transparent;
            }
            .icon {
              display: inline-block;
            }
          }

        }
        
      }


    }

  }

</style>
